import { t } from 'i18next';
import { camelCase, startCase, upperFirst } from 'lodash';

import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { PricingSourceDiscountType, PricingSourceType } from 'pricing/enums';
import { IPriceSourceData } from 'pricing/types';

import BaseSourceHelper from './BaseSourceHelper';

const PriceSourceHelper = {
  getPricingProfileName: (priceSourceData: IPriceSourceData) => {
    const pricingSource = BaseSourceHelper.getPriceSource(priceSourceData);

    return BaseSourceHelper.getPricingProfileName(pricingSource);
  },

  getPricingProfileUrl: (priceSourceData: IPriceSourceData) => {
    const pricingSource = BaseSourceHelper.getPriceSource(priceSourceData);

    return BaseSourceHelper.getPricingProfileUrl(pricingSource);
  },

  getQuantityDiscountsApplied: ({
    priceQuantityDiscountsApplied,
  }: {
    priceQuantityDiscountsApplied?: number;
  }) => {
    return 1 === +priceQuantityDiscountsApplied ? t('labelPriceQuantityDiscountsApplied') : '';
  },

  getTypeLabel: ({ priceSourceType }: { priceSourceType?: PricingSourceType }) => {
    if (!priceSourceType || PricingSourceType.UNSET === priceSourceType) {
      return DEFAULT_PLACEHOLDER;
    }

    return startCase(t(`labelPricingSourceType${upperFirst(camelCase(priceSourceType))}`));
  },

  getDiscountTypeLabel: ({
    priceSourceDiscountType,
  }: {
    priceSourceDiscountType?: PricingSourceDiscountType;
  }) => {
    if (!priceSourceDiscountType) {
      return '';
    }

    if (
      [PricingSourceDiscountType.FIXED_PRICE, PricingSourceDiscountType.FIXED_COST].includes(
        priceSourceDiscountType
      )
    ) {
      return startCase(t('labelPricingSourceDiscountTypeFixed'));
    }

    return startCase(
      t(`labelPricingSourceDiscountType${upperFirst(camelCase(priceSourceDiscountType))}`)
    );
  },
};

export default PriceSourceHelper;
